

// @ts-nocheck

import Vue from "vue";
import Googlereview from "../../../platformlogos/Googlereview.vue";
import Facebook from "../../../platformlogos/Facebook.vue";
import info from "./SVGs/Info.vue";
import Draggable from 'vuedraggable'

export default Vue.extend({
  data() {
    return {
      showContactOptions: false as boolean,
      validOptions: [] as any[],
      keyToString: {
          fb: 'Facebook page',
          gp: 'Google profile',
          contact: 'Business info'
      } as any
    };
  },
  props: {
    fieldAddress: Array,
  },
  created(): void {
    this.refreshOptions();
  },
  methods: {
    refreshOptions(): void {
      //keep track of which actions added to view:
      const allKeys = [
        "fb",
        "gp",
        "contact"        
      ];

      //go through current database value, if any, and see which are valid...      
    if (this.field !== false) {
      // @ts-ignore
      this.field.forEach((entry) => {
        if (entry.key !== "contact") {
          if (this.platformAvailability[entry.key]) {            
            this.validOptions.push({
                ...entry,
                active: true
                });
            allKeys.splice(allKeys.indexOf(entry.key), 1);
          }
        } else {
            this.validOptions.push({
                ...entry,
                });
            allKeys.splice(allKeys.indexOf(entry.key), 1);
        }
        });
      }

      //go through REST of options, see which is valid (but not active)
      allKeys.forEach((entry) => {
        if (entry !== "contact") {
          if (this.platformAvailability[entry]) {            
            this.validOptions.push({
                key: entry,
                active: false
            });
          }
        } else {
            this.validOptions.push({
                key: 'contact',
                phone: false,
                website: false,
                email: false
            });
            }
        });
    },
  },
  watch: {
    validOptions: {
      handler(v): void {        
        //update the field
        const toPush = [] as any[];
        //noconsoleconsole.log(v.length);

        v.forEach((option: any) => {
          
        if (option.key === 'contact') {            
            if (option.email || option.phone || option.website) toPush.push(
                { 
                phone: this.$store.state.dash.viewData.business.businessInfo.businessContact.localNumber ? option.phone: false,                
                email:  this.$store.state.dash.viewData.business.businessInfo.businessEmail ? option.email: false,              
                website: this.$store.state.dash.viewData.business.businessInfo.webAddress ? option.website: false,                
                key: 'contact', 
                
                 }
                );
        } else {
         if (option.active) {
            toPush.push({ key: option.key });
          }
        }
                  
        });

        if (toPush.length === 0) {
          this.field = false;
        } else {
          this.field = toPush;
        }
      },
      deep: true,
    },
  },
  computed: {
    field: {
      get: function (): any[] | false {
        // @ts-ignore
        return this.$store.getters["survey/stepField"](this.fieldAddress);
      },
      set: function (v: string): void {
        // @ts-ignore
        this.$store.commit("survey/CHANGE_FIELD", {
          // @ts-ignore
          fieldAddress: this.fieldAddress,
          val: v,
        });
      },
    },
    platformAvailability(): any {
      //determine if we have addresses/info available for each platform
      const toReturn = {};
      const pltforms = ["fb", "gp", "tw", "tp", "g2", "ca", "ta", "ye", "fs"];
      pltforms.forEach((pf) => {
        if (pf === "gp") {
          toReturn["gp"] = this.$store.state.dash.viewData.business
            .externalPlatforms.gp.gpObject
            ? true
            : false;
        } else {
          toReturn[pf] = this.$store.state.dash.viewData.business
            .externalPlatforms[pf]
            ? typeof this.$store.state.dash.viewData.business.externalPlatforms[
                pf
              ].id !== "undefined"
              ? true
              : false
            : false;
        }
      });
      return toReturn;
    },
  },
  components: {
    gp: Googlereview,
    fb: Facebook,    
    contact: info,
    Draggable,
  },
});
